<template>
  <div
    class="wrong-sms-dialog"
  >
    <div class="v-card-wrapper">
      <div class="v-sheet v-card">
        <div class="v-card__title">
          <span v-html="$t('title')"></span>
        </div>
        <div class="v-card__text">
          <div
            class="wrong-sms-dialog__content"
            v-html="$t('text')"
          ></div>
          <div class="wrong-sms-dialog__contact">
            <img
              :src="require('@project/public/img/wrong-bonus/whatsapp.png')"
              alt=""
            />
            +7 964 568 01 03
          </div>
          <div class="wrong-sms-dialog__contact">
            <img
              :src="require('@project/public/img/wrong-bonus/phone.png')"
              alt=""
            />
            8 800 200 80 88
          </div>
        </div>
      </div>
    </div>
    <div class="after">
      <div v-if="$projectName === $projectNames.MTI">
        <div class="wrong-sms-dialog__decor">
          <div class="wrong-sms-dialog__decor-wrap">
            <span></span>
          </div>
          <div class="wrong-sms-dialog__decor-wrap">
            <span></span>
          </div>
          <div class="wrong-sms-dialog__decor-wrap">
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import './SmsWrongBonusDialog.scss';
import { $i18n } from '@/shared/helpers/i18n';

export default defineComponent({
  name: 'SmsWrongBonusDialog',
  setup() {
    $i18n.mergeLocaleMessage('ru', {
      title: 'Чтобы получить приветственный бонус <br> в 5000 токенов, заверши регистрацию <br> в программе Synergy Friends.',
      text: 'Если тебе ошибочно выдали карту<br> другой программы лояльности («Мой капитал» или Команды МАП),<br> <b>срочно обратись к персональному менеджеру:</b>',
    });
  },
});
</script>
